/**
 * List of feedback schedule master rows (admin)
 */

function formatDate(value) {
  if (!value) return '-';
  return new Date(value).toLocaleString();
}

function formatType(value) {
  return String(value || 'SEMESTER')
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export default function FeedbackCyclesTable({ cycles, cycleActionId, onActivate, onDeactivate }) {
  if (cycles.length === 0) {
    return (
      <div className="admin-empty py-8">
        <p className="admin-empty-title">No current semester schedule</p>
        <p className="admin-empty-text">Set the current academic term calendar, then save a student feedback timeline for the current semester.</p>
      </div>
    );
  }

  return (
    <div className="table-wrap">
      <table className="table">
        <thead>
          <tr>
            <th>Schedule</th>
            <th>Feedback family</th>
            <th>Academic year</th>
            <th>Semester</th>
            <th>Window</th>
            <th>Forms</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {cycles.map((c) => (
            <tr key={c.id}>
              <td>
                <div className="font-medium">{c.name || '-'}</div>
                <div className="text-xs text-slate-500">{c.schedule_scope || 'INSTITUTE_WIDE'}</div>
              </td>
              <td>{formatType(c.type)}</td>
              <td>{c.academic_year || '-'}</td>
              <td>{c.semester != null ? `Semester ${c.semester}` : '-'}</td>
              <td>
                <div>{formatDate(c.start_date)}</div>
                <div className="text-xs text-slate-500">to {formatDate(c.end_date)}</div>
              </td>
              <td>{Number(c.form_count || 0)}</td>
              <td>
                {c.is_currently_open ? (
                  <span className="assign-role-badge assign-role-badge-primary">Open now</span>
                ) : c.is_active ? (
                  <span className="assign-role-badge">Active, outside date</span>
                ) : c.is_in_date_window ? (
                  <span className="assign-role-badge">Ready to activate</span>
                ) : (
                  <span className="assign-role-badge">Closed</span>
                )}
              </td>
              <td>
                {c.is_active ? (
                  <button
                    type="button"
                    onClick={() => onDeactivate(c.id)}
                    disabled={cycleActionId === c.id}
                    className="text-amber-600 hover:underline text-xs disabled:opacity-50"
                  >
                    Deactivate
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={() => onActivate(c.id)}
                    disabled={cycleActionId === c.id || !c.is_in_date_window}
                    className="text-indigo-600 hover:underline text-xs disabled:opacity-50"
                    title={!c.is_in_date_window ? 'Only current semester schedules inside the active term window can be activated.' : 'Activate and notify stakeholders'}
                  >
                    {c.is_in_date_window ? 'Activate and notify' : 'Not current'}
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
